// extracted by mini-css-extract-plugin
export default {"wrapper":"SuperOrderModal_wrapper__IDejC","modal":"SuperOrderModal_modal__zrYh8"};